<template>
    <ValidationProvider :vid="vid" :name="$attrs.name || $attrs.label" :rules="rules" v-slot="{ errors, valid }">
        <b-field :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors" v-bind="$attrs">
            <b-input v-model="innerValue" v-bind="$attrs"></b-input>
        </b-field>
    </ValidationProvider>
</template>

<script>
import { ValidationProvider, extend } from "vee-validate";
import { integer, max_value, min_value, required } from 'vee-validate/dist/rules';
extend('required', required);
extend('integer', integer);
extend('max_value', max_value);
extend('min_value', min_value);

export default {
    components: {
        ValidationProvider,
    },
    props: {
        vid: String,
        rules: {
            type: [Object, String],
            default: "",
        },
        value: null,
    },
    data: () => ({
        innerValue: "",
    }),
    created() {
        if (this.value) {
            this.innerValue = this.value;
        }
    },
    watch: {
        innerValue(newVal) {
            this.$emit("input", newVal);
        },
        value(newVal) {
            this.innerValue = newVal;
        },
    },
};
</script>
